import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import DatasetSelectTrend from '../common/select-filters/DatasetSelectTrend';
import MentalRiskCharts from '../common/charts/MentalRiskCharts';
import TrendDiagram from '../common/charts/TrendDiagram';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import { mentalRisk } from '../../model/subMenuTabs';

const PsychosocialRisk = props => {

	const currentPath = '/working-conditions-preventions/mental-risk/';

	const [selectedTab, setSelectedTab] = useState(null);
	
	const [secondLevelTabs, setSecondLevelTabs] = useState(null);
	const [secondLevelSelected, setSecondLevelSelected] = useState(null);
	const [secondLevelIndicator, setSecondLevelIndicator] = useState(undefined);
	const [chartLegend, setChartLegend] = useState(null);

	const [selectedSurvey, setSelectedSurvey] = useState(props.dataset);
	const [methodologyIndicator, setMethodologyIndicator] = useState(null);
	
	const [isTrend, setIsTrend] = useState(false);
	const [selectedSortBy, setSelectedSortBy] = useState(false);
	const [selectedAnswer, setSelectedAnswer] = useState(undefined);
	const [selectedDataset1, setSelectedDataset1] = useState(undefined);
	const [selectedDataset2, setSelectedDataset2] = useState(undefined);

	const [hasTrend, setHasTrend] = useState(null);

	const [defaultDataset, setDefaultDataset] = useState(null);
	const [selectDataset1IsDisabled, setSelectDataset1IsDisabled] = useState(false);
	const [dimension, setDimension] = useState(window.innerWidth > 768 ? 'column' : 'bar');
	const [showSecondLevel, setSecondLevel] = useState(false);

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22013 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		let selectedTabValue = '', secondLevel = '', secondLevelSelectedTab;
		let indicator = '';
		let showTrend = true;
		let defaultDatasetValue = [];

		// Get the selected tab at the first level
		selectedTabValue = mentalRisk.filter(tab => tab.url == props.tab);
		for (let i = 0; i < mentalRisk.length; i++)
		{
			if (mentalRisk[i].url == props.tab)
			{
				selectedTabValue = mentalRisk[i];
			}
		}

		if (selectedTabValue.subTabs != undefined)
		{
			secondLevel = selectedTabValue.subTabs;

			// Get the selected tab at the second level
			for (let i = 0; i < selectedTabValue.subTabs.length; i++)
			{
				if (selectedTabValue.subTabs[i].url == props.indicator)
				{
					secondLevelSelectedTab = selectedTabValue.subTabs[i];

					if (secondLevelSelectedTab.chartType.length > 1)
					{
						for (let j = 0; j < secondLevelSelectedTab.chartType.length; j++)
						{
							if (props.dataset == secondLevelSelectedTab.chartType[j].type)
							{
								indicator = secondLevelSelectedTab.chartType[j].chartIndicator;
								showTrend = secondLevelSelectedTab.chartType[j].hasTrend;
								defaultDatasetValue.push({ url: secondLevelSelectedTab.url, dataset: secondLevelSelectedTab.chartType[j].type });
							}
						}
					}
					else
					{
						indicator = secondLevelSelectedTab.chartType[0].chartIndicator;
						showTrend = secondLevelSelectedTab.chartType[0].hasTrend;
						defaultDatasetValue.push({ url: secondLevelSelectedTab.url, dataset: secondLevelSelectedTab.chartType[0].type });
					}
				}
				else
				{
					defaultDatasetValue.push({ url: selectedTabValue.subTabs[i].url, dataset: selectedTabValue.subTabs[i].chartType[0].type });
				}
			}
		}

		setSelectedTab(selectedTabValue);
		setSecondLevelTabs(secondLevel);
		setSecondLevelSelected(secondLevelSelectedTab);
		setChartLegend(secondLevelSelectedTab.legend);
		setMethodologyIndicator(indicator);
		setHasTrend(showTrend);
		setDefaultDataset(defaultDatasetValue);
		setSecondLevel(secondLevel != '' && secondLevel.length > 0 ? true : false)

		setIsLoading(false);
	}, [])

    const callbackSelectedTab = (callback) => {
		setSecondLevel(true);

        for (let i = 0; i < mentalRisk.length; i++)
        {
            if (callback == mentalRisk[i].url)
            {
                let selected = mentalRisk[i];
				let defaultDatasetValue = [];

				for (let i = 0; i < selected.subTabs.length; i++)
				{
					defaultDatasetValue.push({ url: selected.subTabs[i].url, dataset: selected.subTabs[i].chartType[0].type });
				}
				
				setSelectedTab(selected);
				setSecondLevelTabs(selected.subTabs);
				setSecondLevelSelected(selected.subTabs[0]);
				setDefaultDataset(defaultDatasetValue);
            }
        }	
	}

    const callbackSelectedIndicator = (callback) => {
		setSecondLevelIndicator(callback);

		let source = defaultDataset.find((element) => element.url == callback).dataset;
		let hasTrend = true;

		for (let i = 0; i < secondLevelTabs.length; i++)
		{
			if (callback == secondLevelTabs[i].url)
			{
                let secondLevelSelectedTab = secondLevelTabs[i];
                let methodologyIndicator;

                if (secondLevelSelectedTab.chartType.length == 1)
                {
                    // The indicator is the only one defined for the current tab
                    methodologyIndicator = secondLevelSelectedTab.chartType[0].chartIndicator;
                    hasTrend = secondLevelSelectedTab.chartType[0].hasTrend;
                }
                else
                {
                    // Select the indicator for the selected dataset
                    methodologyIndicator = secondLevelSelectedTab.chartType.find((element) => element.type == source).chartIndicator;
                    hasTrend = secondLevelSelectedTab.chartType.find((element) => element.type == source).hasTrend;
                }

                if(callback != 'fear-of-job-loss' && callback != 'working-hours'){
					// Set dataset as null so the selectedDataset is not one from ESENER when painting the chart
					setSelectedDataset1("null");
				}

				setSecondLevelSelected(secondLevelSelectedTab);
				setMethodologyIndicator(methodologyIndicator);
				setIsTrend(false);
				setHasTrend(hasTrend);
				setSelectedSurvey(source);
			}
		}
	}

    const callbackSelectedSurvey = (callback) => {
		let defaultDatasetValue = defaultDataset;
		let selectedDataset1Value = selectedDataset1;
		if (!isTrend)
		{
			// Get the current selected tab
			let i = defaultDatasetValue.findIndex(tab => tab.url == secondLevelSelected.url)
			// Update the element
			defaultDatasetValue[i].dataset = callback;

			// Set dataset as null so the selectedDataset is not one from ESENER when painting the chart
			selectedDataset1Value = "null"
		}
		setSelectedSurvey(callback);
		setDefaultDataset(defaultDatasetValue);
		setSelectedDataset1(selectedDataset1Value);

		for (let i = 0; i < secondLevelSelected.chartType.length; i++)
		{
			if (secondLevelSelected.chartType[i].type == callback)
			{
				setMethodologyIndicator(secondLevelSelected.chartType[i].chartIndicator);
				setHasTrend(secondLevelSelected.chartType[i].hasTrend);
			}
		}
	}

    const callbackChartLegend = (legend) => {
		setChartLegend(legend);
	}

    const handleAnswerChange = (callback) => {
		setSelectedAnswer(callback);
	}

    const handleDatasetChange1 = (dataset, indicator, isDisabled) => {
		setSelectedDataset1(dataset);
		setSelectDataset1IsDisabled(isDisabled);
	}

    const handleDatasetChange2 = (dataset, indicator) => {
		setSelectedDataset2(dataset);
	}

    const handleSortButton = () => {
		setSelectedSortBy(!selectedSortBy);
    }

    const handleTrendButton = () => {
		setIsTrend(!isTrend);
		setSelectedDataset2(!isTrend ? undefined : selectedDataset2);
	}

	if (isLoading)
	{
		return null;
	}

	return(
		<div className="mental-risk">
			<AdviceSection literals={props.literals} section={["working-conditions-preventions","mental-risk"]} methodologyData={{section: 'working-conditions-preventions', subsection: 'Working conditions - Mental risk', indicator: 83}} />

			{/*First submenu*/}
			<SubMenuTabs 
				literals={ props.literals }
				selectedTab={ selectedTab.url }
				callbackSelectedTab={ callbackSelectedTab }
				locationPath={ currentPath }
				subMenuTabs={ mentalRisk }
			/>
			<div className='line background-main-light'></div>

			{/*Second submenu*/}
			<SubMenuTabs 
				literals={ props.literals }
				selectedTab={ secondLevelSelected.url }
				selectedSurvey={ selectedSurvey }  
				callbackSelectedTab={ callbackSelectedIndicator }
				locationPath={ `${currentPath}${selectedTab.url}/` }
				subMenuTabs={ secondLevelTabs } 
			/>
			<div className="line background-main-light" />

			<DatasetSelectTrend
				literals={ props.literals }
				chartType={ secondLevelSelected.chartType }
				callbackSelectedSurvey={ callbackSelectedSurvey }
				handleAnswerChange={ handleAnswerChange }
				handleDatasetChange1={ handleDatasetChange1 }
				handleDatasetChange2={ (e) => handleDatasetChange2(e) }
				showSourceSelect={ true }
				showAnswerSelect={ isTrend }
				selectedIndicator={ selectedSurvey }
				yearOnly={ isTrend ? false : true }
			/>
			<div className="line background-main-light"></div>

			<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text" >
				<div className="card--block--chart with-filters" >
					<div className={`card--btn-wrapper ${ selectedSurvey != 'flash' ? 'with-button' : 'only-switch' }`}>
						<div className="select-filter-chart-wrapper">
							{ !isTrend && (<div className="switch--button">
								<input type="checkbox" name="switch-button" id="switch-label" className="switch--button-checkbox" defaultChecked={ selectedSortBy } />
								<label htmlFor="switch-label" className="switch--button-label" onClick={ handleSortButton }></label>
								<label htmlFor="switch-label" className="text-label" onClick={ handleSortButton }>{ props.literals["L20341"] }</label>
							</div>)}
						</div>
						{( selectedSurvey != 'flash' && hasTrend) && (
							<div className='btn-trend-container'>
								<a className="btn-default btn-main-color ng-binding btn-trend" onClick={ handleTrendButton }>{ !isTrend ? props.literals["L20287"] : props.literals["L20311"] }</a>
							</div>
						)}
					</div>
					<div className="chart--block with-filter" >
						<div className="card--block--chart--wrapper" >
							<div className="chart--wrapper" >
								{!isTrend ? 
								<MentalRiskCharts
									literals={ props.literals }
									tabIndicator={ secondLevelSelected.literalTab }
									chartType={ secondLevelSelected.chartType }
									selectedIndicator={ selectedSurvey }
									selectedDataset={ selectedDataset1 }
									colors={ ['#489FA1','#ffe400','#7b7b7d', '#cbe2e3','#f6a300'] }
									percentage={ true }
									callbackLegend={ callbackChartLegend }
									callbackSelectedSurvey={ callbackSelectedSurvey }
									exportingEnabled={ true }
									showSelect={ secondLevelSelected.chartType.length > 1 ? true : false }
									showDatasetSelect={ false }
									selectedSortBy={ selectedSortBy }
								/> : 
								<TrendDiagram
									literals={ props.literals }
									tabIndicator={ secondLevelSelected.literalTab }
									chartType={ secondLevelSelected.chartType }
									selectedIndicator={ selectedSurvey }
									selectedAnswer={ selectedAnswer }
									selectedDataset1={ selectedDataset1 }
									selectedDataset2={ selectedDataset2 }
									colors={ ['#f6a300', '#cbe2e3'] }
									type={ dimension }
								/>}
							</div>
						</div>
					</div>
				</div>
				<div className="chart-legend">
					{ReactHtmlParser(props.literals[`L${chartLegend}`])}
				</div>
			</div>

			<Methodology literals={ props.literals } section={'Working conditions - Mental risk'} indicator={ methodologyIndicator } />

			<Related literals={ props.literals } section={["working-conditions-preventions","mental-risk", secondLevelSelected.url]} dataset={ selectedSurvey } />
		</div>
	)
}
PsychosocialRisk.displayName = 'PsychosocialRisk';
export default PsychosocialRisk;